export const commonButtonProps = {
    variant: 'contained',
    color: 'primary',
    size: 'small',
    sx: { maxWidth: 100 },
};
